@if (state === LoadingState.LOADING) {
  <bdo-loading></bdo-loading>
}

@if (state === LoadingState.ERROR) {
  <div class="bdo-container--single">
    Fehler beim Laden. Gehen Sie zurück zur Übersicht oder loggen sich erneut ein.
  </div>
}
